import { useMutation, UseMutationResult, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { enum_api_uri } from "../../../utils/enum";
import { useAuthStore } from "../../../../../console/store/useAuthStore";

export const usePutCustomerOption = (
    successCallback?: () => void,
): UseMutationResult<null, Error, { id: number; optionId: number }, unknown> => {
    const queryClient = useQueryClient();
    const accessToken = useAuthStore(state => state.accessToken);

    return useMutation<null, Error, { id: number; optionId: number }>({
        mutationFn: async ({ id, optionId }: { id: number; optionId: number }) => {
            const response = await axios.put(
                `${enum_api_uri.put_customer_option.replace(":customer_id", id.toString()).replace(":customer_option_idx", optionId.toString())}`,
                {},
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                },
            );
            return response.data.data;
        },
        onSuccess: (data, variables) => {
            const customerId = variables.id;
            queryClient.invalidateQueries({ queryKey: ["getCustomerInfo", customerId] });
            successCallback?.();
        },
    });
};
